import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { MapService } from 'src/app/Service/map.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { Circle, Fill, Stroke, Style, Text } from "ol/style";
import { BingMaps, Cluster, Vector, XYZ } from "ol/source";
import { Point } from "ol/geom";
import Map from 'ol/Map';
import View from 'ol/View';
import * as olProj from 'ol/proj';
import Feature from 'ol/Feature';
import OSM from 'ol/source/OSM';
import AnimatedCluster from "ol-ext/layer/AnimatedCluster";
import SelectCluster from "ol-ext/interaction/SelectCluster";
import TileLayer from 'ol/layer/Tile';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import { Polygon } from "ol/geom";
declare let $: any;
import "ol/ol.css";

import axios from "src/app/Service/axios";


@Component({
  selector: 'app-tanker-show-all-map',
  templateUrl: './tanker-show-all-map.component.html',
  styleUrls: ['./tanker-show-all-map.component.css']
})

export class TankerShowAllMapComponent implements OnInit {
  supplyDetails: any = [];
  supplyGeofence: any = [];
  map: any = {};
  acssess: any;
  source: any;
  vector: any;
  layers: any = [];
  vectorLayer: any;

  readonly bOfflineMap: boolean = (<any>window).bOfflineMap;
  readonly strMapUrl: string = (<any>window).strMapUrl;

  constructor(
    private _tooltip: NotificationService,
    private FormBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private gurdService: GurdServiceService,
    private _otherService: OtherService,
    private mapService: MapService
  ) { }

  ngOnInit(): void {
    try {
      const encryptedData = localStorage.getItem('supplyDetails');

      if (!encryptedData) {
        this._tooltip.showWarning('supplyDetails not found in localStorage', 'error');
        return;
      }

      const decryptedData = this.gurdService.decrypt(encryptedData);
      this.supplyDetails = JSON.parse(decryptedData);

      this.intializeMap()

    } catch (error) {
      console.error('Error loading supplyDetails:', error);
    }
  }

  async intializeMap() {

    await this.fetchGeoFence();

    setTimeout(() => {

      this.source = new VectorSource({ wrapX: false });
      this.vector = new VectorLayer({
        source: this.source,
      });

      if (this.bOfflineMap) {
        this.layers.push(
          new TileLayer({
            source: new XYZ({
              url: this.strMapUrl,
              attributions: 'Map data © RayanAndishehNasr' // 
            }),
          })
        );
      }

      else {
        const styles = [
          'AerialWithLabelsOnDemand',
        ];

        let i, ii;
        for (i = 0, ii = styles.length; i < ii; ++i) {
          this.layers.push(
            new TileLayer({
              visible: false,
              preload: Infinity,
              source: new BingMaps({
                key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',
                imagerySet: styles[i],
              }),
            }),
          );
        }
        this.layers.push(new TileLayer({ source: new OSM({}) }), this.vector)
      }

      this.map = new Map({
        target: "supplyDetailsMap",
        view: new View({
          zoom: 14,
          center: olProj.fromLonLat([51.3833554, 35.6770113])
        }),
        layers: this.layers
      });

      this.map.on('movestart', () => {
        this.hideTooltip();
      });

      this.map.on('pointerdrag', () => {
        this.hideTooltip();
      });

      this.clustersLayer(this.supplyDetails);
      this.showPolygon(this.supplyGeofence[0].lstPoints)

    }, 500);


  }

  clustersLayer(data: any) {
    setTimeout(() => {
      this.map.on("click", (e: any) => {
        if (e.dragging) { return; }

        let found = false;

        this.map.forEachFeatureAtPixel(
          this.map.getEventPixel(e.originalEvent),
          (feature: any) => {
            if (feature && feature.get('features')) {
              let el = { featureLayer: { feature: feature } }; 
              this.showData(el, e);
              found = true;
            }
            return true; 
          },
          {
            layerFilter: (layer: any) => layer.get('isPolygon') !== true
          }
        );

        if (!found) {
          this.hideTooltip();
        }
      });

    }, 200);

    var clusterSource = new Cluster({
      distance: 40,
      source: new Vector()
    }) as any;


    let addFeatures = (nb: any) => {
      var ext = this.map.getView().calculateExtent(this.map.getSize());
      var features = [];
      for (var i = 0; i < data.length; ++i) {
        features[i] = new Feature({
          type: 'removable',
          geometry: new Point(this.mapService.transformCoordinates2([data[i]?.fSLon || data[i]?.fLon, data[i]?.fSLat || data[i]?.fLat])),
          id_: data[i]?.strUnitID || data[i]?.iPreregistration,
          data: { index: i, ...data[i] },

        });
        features[i].set("id", i);
      }
      clusterSource.getSource().clear();
      clusterSource.getSource().addFeatures(features);

    }

    var styleCache = {} as any;
    function getStyle(feature: any, resolution: any) {
      var size = feature.get("features").length;
      var style = styleCache[size];
      if (!style) {
        var color = size > 25 ? "192,0,0" : size > 8 ? "255,128,0" : "0,128,0";
        var radius = Math.max(8, Math.min(size * 0.75, 20));
        var dash = (2 * Math.PI * radius) / 6;
        var dashs = [0, dash, dash, dash, dash, dash, dash];
        style = styleCache[size] = new Style({
          image: new Circle({
            radius: radius,
            stroke: new Stroke({
              color: "rgba(" + color + ",0.5)",
              width: 15,
              lineDash: dashs,
              lineCap: "butt"
            }),
            fill: new Fill({
              color: "rgba(" + color + ",1)"
            })
          }),
          text: new Text({
            text: size.toString(),
            fill: new Fill({
              color: "#fff"
            })
          })
        });
      }
      return style;
    }

    var clusterLayer = new AnimatedCluster({
      source: clusterSource,
      animationDuration: 700,
      style: getStyle
    });

    this.map.addLayer(clusterLayer);

    addFeatures(2000);

    var style1 = new Style({
      image: new Circle({
        radius: 5,
        stroke: new Stroke({
          color: "rgba(128,0,0,0.8)",
          width: 2
        }),
        fill: new Fill({
          color: "rgba(128,0,0,0.8)"
        })
      }),
      stroke: new Stroke({
        color: "#fff",
        width: 1
      })
    });

    var selectCluster = new SelectCluster({
      pointRadius: 7,
      animate: true,
      layers: [clusterLayer],
      featureStyle: function () {
        return [style1];
      },
      style: function (f, res) {
        var cluster = f.get("features");
        if (cluster.length > 1) {
          return getStyle(f, res);
        } else {
          return [
            new Style({
              image: new Circle({
                stroke: new Stroke({
                  color: "rgba(0,0,192,0.5)",
                  width: 2
                }),
                fill: new Fill({ color: "rgba(0,0,192,0.3)" }),
                radius: 5
              })
            })
          ];
        }
      }
    });

    this.map.addInteraction(selectCluster);

    this.fitMapArray(data);

  }

  fitMapArray(data: any) {
    data = data.filter(function (el: any) {
      return (el?.fSLon != 0 || el?.fLon != 0);
    });

    var maxLatitude = Math.max.apply(Math,
      data.map(function (o: any) {
        return (o?.fSLat || o?.fLat);
      })
    );

    var maxLongitude = Math.max.apply(Math,
      data.map(function (o: any) {
        return (o?.fSLon || o?.fLon);
      })
    );

    var minLatitude = Math.min.apply(Math,
      data.map(function (o: any) {
        return (o?.fSLat || o?.fLat);
      })
    );

    var minLongitude = Math.min.apply(Math,
      data.map(function (o: any) {
        return (o?.fSLon || o?.fLon);
      })
    );

    var view = this.map.getView();
    var transformedStart = this.mapService.transformCoordinates2([
      maxLongitude + (data.length > 1 ? 4 : 0),
      maxLatitude + (data.length > 1 ? 4 : 0),
    ]);

    var transformedEnd = this.mapService.transformCoordinates2([
      minLongitude - (data.length > 1 ? 4 : 0),
      minLatitude - (data.length > 1 ? 4 : 0),
    ]);

    var source = [
      Math.min(transformedStart[0], transformedEnd[0]) - 6000,
      Math.min(transformedStart[1], transformedEnd[1]) - 6000,
      Math.max(transformedStart[0], transformedEnd[0]) + 6000,
      Math.max(transformedStart[1], transformedEnd[1]) + 6000,
    ];

    view.fit(source);
    if (data.length == 1) {
      this.map.getView().setZoom(14);
    }
  }

  showData(item: any, event: any) {

    if (item.featureLayer && item.featureLayer.feature && item.featureLayer.feature.values_.features.length === 1) {

      const data = item.featureLayer.feature.values_.features[0].values_.data;

      const tooltipHtml = `
      <div class="card--map shadow-sm border-0">
        <div class="card--map-body p-2">
          <div><strong>تانکر:</strong> ${data.strFullName || '-'}</div>
          <div><strong>تاریخ:</strong> ${data.strDate || '-'}</div>
          <div><strong>شروع:</strong> ${data.strSTime || '-'}</div>
          <div><strong>پایان:</strong> ${data.strETime || '-'}</div>
          <div><strong>حجم (لیتر):</strong> ${data.fFeedingValue.toLocaleString() || 0}</div>
        </div>
      </div>
    `;

      const tooltip = document.getElementById('map_tooltips');

      if (tooltip) {

        tooltip.innerHTML = tooltipHtml;

        tooltip.style.display = 'block';
        tooltip.style.position = 'absolute';

        tooltip.style.left = event.originalEvent.offsetX + 'px';
        tooltip.style.top = (event.originalEvent.offsetY - 10) + 'px';

        tooltip.style.zIndex = '9999';
        tooltip.style.background = '#fff';
        tooltip.style.borderRadius = '6px';
      }
    }

    else {
      this.hideTooltip();
    }
  }

  hideTooltip() {
    const tooltip = document.getElementById('map_tooltips');

    if (tooltip) {
      tooltip.style.display = 'none';
      tooltip.innerHTML = '';
    }
  }

  private async fetchGeoFence() {

    const model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
      bShower: true
    }
    this._otherService.Showspinner();

    const res = JSON.parse((await axios.post('Radyab_GeoFence', model)).data.toString()
    );

    this._otherService.nonespinner();

    localStorage.removeItem('supplyGeofence');
    const encrypted = this.gurdService.encrypt(JSON.stringify(res));
    localStorage.setItem('supplyGeofence', encrypted);

    this.supplyGeofence = res;
  }

  private showPolygon(point: any[],) {
    if (this.supplyGeofence.length) {
      this.mapService.removeLayerByName('polygon', this.map);
    }

    if (this.vectorLayer) {
      this.map.removeLayer(this.vectorLayer);
    }

    if (point.length != 0) {
      var ring = [];

      for (let index = 0; index < point.length; index++) {
        ring.push([point[index].fLon, point[index].fLat]);
      }

      var polygon = new Polygon([ring]);

      polygon.transform('EPSG:4326', 'EPSG:3857');

      var feature = new Feature(polygon);

      var vectorSource = new VectorSource();

      vectorSource.addFeature(feature);

      var vectorLayer = new VectorLayer({
        source: vectorSource,
        name: 'polygon',
        renderMode: 'image',
        declutter: false,
        style: new Style({
          stroke: new Stroke({
            color: 'blue',
            width: 4,
            lineDash: [10, 20, 10, 20]
          }),
          fill: new Fill({
            color: 'rgba(0, 0, 255, 0)'
          })
        }),
        properties: { isPolygon: true }

      } as any);

      this.vectorLayer = vectorLayer;
      this.map.addLayer(vectorLayer);
    }
  }
}
